import FlowioHiddenInput from "./FlowioHiddenInput";

export default FlowioHiddenInput;
export type { FlowioHiddenInputProps } from "./FlowioHiddenInput";
